"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

require("./ErrorPage.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorPage = function ErrorPage(_ref) {
	var location = _ref.location;
	return _react2.default.createElement(
		_semanticUiReact.Container,
		{ textAlign: "center", style: { paddingTop: "5em" } },
		_react2.default.createElement(
			_semanticUiReact.Segment.Group,
			null,
			_react2.default.createElement(
				_semanticUiReact.Segment,
				{ color: "teal" },
				_react2.default.createElement(_semanticUiReact.Image, { size: "mini", src: "./TV3.svg", style: { margin: "1em" }
				})
			),
			_react2.default.createElement(
				_semanticUiReact.Segment,
				{ inverted: true, color: "teal", placeholder: true },
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ as: "h1", icon: true },
					_react2.default.createElement(_semanticUiReact.Icon, { name: "frown outline" }),
					"Ups!"
				),
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ as: "h3" },
					"P\xE0gina no trobada a ",
					_react2.default.createElement(
						"i",
						null,
						location.pathname
					)
				)
			),
			_react2.default.createElement(
				_semanticUiReact.Segment,
				{ color: "teal" },
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ size: "medium", color: "teal" },
					"Anar a:"
				),
				_react2.default.createElement(
					_reactRouterDom.Link,
					{ style: { color: "white" }, to: "/editor" },
					_react2.default.createElement(
						_semanticUiReact.Button,
						{ color: "teal" },
						_react2.default.createElement(_semanticUiReact.Icon, { name: "edit" }),
						" Editor"
					)
				),
				_react2.default.createElement(
					_reactRouterDom.Link,
					{ style: { color: "white" }, to: "/gestor" },
					_react2.default.createElement(
						_semanticUiReact.Button,
						{ color: "teal" },
						_react2.default.createElement(_semanticUiReact.Icon, { name: "list" }),
						"Gestor"
					)
				)
			)
		)
	);
}; //      

// Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

exports.default = ErrorPage;


ErrorPage.propTypes = {
	location: _propTypes2.default.object
};
